angular.module('impactx.MenuDirectives').directive('ixDeactivateThemeWorldSearch', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateThemeWorldSearchCtrl',
        controllerAs: 'deactivateThemeWorldSearchCtrl',
        templateUrl: 'shared/menu/templates/deactivatethemeworldsearch.tmpl.html'
    }
});